import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IOtherUserRequest } from '../interfaces/users';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../constants/api-endpoints';
import { HttpUtilityService } from './http.utility.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class UserOtherApiService {
  constructor(
    private readonly httpUtilityService: HttpUtilityService,
    private readonly commonService: CommonService
  ) {}

  userEmail = sessionStorage.getItem('UserEmail') || '';

  searchRequests(filters: any): Observable<HttpResponse<IOtherUserRequest[]>> {
    const url = `${apiEndpoints.otherPnaSearch}`;

    const requestDto: any = {};
    if (filters.companyCode) requestDto.Ccn = filters.companyCode;
    if (filters.buyer) requestDto.Buyer = filters.buyer;
    if (filters.purchasingOffice)
      requestDto.Purchasing = filters.purchasingOffice;
    if (filters.status) requestDto.Status = filters.status;
    if (filters.pnaNo) {
      const { pnaNo } = this.commonService.extractPNA(filters.pnaNo || '');
      requestDto.PnaNo = pnaNo;
    }

    return this.httpUtilityService.post<IOtherUserRequest[]>(url, requestDto);
  }
}
